import { render, staticRenderFns } from "./partsInventoryRecords.vue?vue&type=template&id=d1d5d8d4"
import script from "./partsInventoryRecords.vue?vue&type=script&lang=js"
export * from "./partsInventoryRecords.vue?vue&type=script&lang=js"
import style0 from "./partsInventoryRecords.vue?vue&type=style&index=0&id=d1d5d8d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports